import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslate } from "../i18n";

export default function SidebarNavItem({
  path,
  label,
  Icon,
  iconColor,
  collapsed,
  currentPath,
  onClick,
}) {
  const active =
    currentPath === path || (path !== "/" && currentPath.startsWith(path));
  const [hov, setHov] = useState(false);
  const { t } = useTranslate();
  const icoColor = iconColor || "var(--muted2)";

  return (
    <Link
      to={path}
      onClick={onClick}
      className="e-touch-target"
      title={collapsed ? t(label) : undefined}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: collapsed ? "10px 14px" : "9px 12px",
        minHeight: 38,
        borderRadius: 8,
        textDecoration: "none",
        background: active
          ? "var(--accent-g)"
          : hov
            ? "var(--hover-bg)"
            : "transparent",
        color: active ? "var(--text)" : "var(--muted2)",
        fontWeight: active ? 600 : 400,
        fontSize: 13,
        transition: "all 0.15s",
        whiteSpace: "nowrap",
        overflow: "hidden",
      }}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
    >
      <span
        style={{
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          color: active || hov ? icoColor : icoColor + "bb",
          transition: "color 0.15s",
        }}
      >
        <Icon s={16} />
      </span>
      {!collapsed && (
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", flex: 1 }}>
          {t(label)}
        </span>
      )}
      {!collapsed && active && (
        <span
          style={{
            width: 4,
            height: 4,
            borderRadius: 2,
            background: icoColor,
            flexShrink: 0,
          }}
        />
      )}
    </Link>
  );
}
